module.exports = __webpack_public_path__ + "static/media/Logo-White.e739b3c7.svg";